import { ReduxSimpleActionInterface } from '@ecommerce/nest-ssr/dist/common';
import { ListingType, ListingTypesEnum } from 'modules/shared/modules/categories-shared/interfaces/category-listing-config.interface';
import { setCookie } from 'helpers/cookie';

export enum ProductViewActions {
    list = 'VIEW_LIST',
    grid = 'VIEW_GRID',
    lifestyle = 'VIEW_LIFESTYLE'
}

export const listingType = [
    (
        state: ListingType,
        action: ReduxSimpleActionInterface<ProductViewActions.list, { payload: { pageTypeName: string; }; }> |
            ReduxSimpleActionInterface<ProductViewActions.grid, { payload: { pageTypeName: string; }; }> |
            ReduxSimpleActionInterface<ProductViewActions.lifestyle>
    ): ListingType => {
        switch (action.type) {
            case ProductViewActions.list:
                setCookie('listingType', JSON.stringify([action.payload.pageTypeName, ListingTypesEnum.List]), { expiresDays: 30, path: '/', secure: true });

                return ListingTypesEnum.List;
            case ProductViewActions.grid:
                setCookie('listingType', JSON.stringify([action.payload.pageTypeName, ListingTypesEnum.Grid]), { expiresDays: 30, path: '/', secure: true });

                return ListingTypesEnum.Grid;
            case ProductViewActions.lifestyle:

                return ListingTypesEnum.Lifestyle;
            default:
                return state;
        }
    }
];
